export default __webpack_public_path__ + "static/media/no-image-product.0fd73fb2.png";